import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../../../redux/actions/user.actions";
import {
  certificatesDataToFormData,
  getUserPayload,
} from "../../../system";
import { ToastifyService } from "../../../services";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const BaseBecomeCertifiedPractitioner = (props) => {
  const { children } = props;
  const { t } = useTranslation();
  const methods = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userData, setUserData] = useState("");

  const formState = useSelector(
    (state) => state?.UserReducer?.qualificationDocFormState
  );

  const { handleSubmit } = methods;

  const onSubmit = async () => {
    if (!formState?.length) {
      ToastifyService.showError(t(translationConstants.selectDocument));
      return; // Exit the function to prevent form submission
    }

    const certificates = { certificates: formState };
    const dataToSend = certificatesDataToFormData(certificates);
    // const dataToSend = convertArrayToFormData(formState);

    const action = props.isInstructor
      ? UserActions.becomeInstructor
      : UserActions.certifiedPractitioner;

    dispatch(
      action(dataToSend, userData.id, navigate, () => {
        dispatch(UserActions.setQualificationFormState([]));
      })
    );
  };

  useEffect(() => {
    const storedUserData = getUserPayload();
    if (storedUserData?.user) {
      setUserData(storedUserData.user);
    }
  }, []);

  return (
    <FormProvider {...methods}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="BecomeCertifiedPractitionerBase">{children}</div>
      </Form>
    </FormProvider>
  );
};

export default BaseBecomeCertifiedPractitioner;
